interface IconProps {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export const CryptoIcon = ({
  size = 21,
  width,
  height,
  fill = "white",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width || size}
      height={height || size * (18 / 21)}
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.75 4H16.75V3C16.75 2.20435 16.4339 1.44129 15.8713 0.87868C15.3087 0.316071 14.5456 0 13.75 0H3.75C2.95435 0 2.19129 0.316071 1.62868 0.87868C1.06607 1.44129 0.75 2.20435 0.75 3V15C0.75 15.7956 1.06607 16.5587 1.62868 17.1213C2.19129 17.6839 2.95435 18 3.75 18H17.75C18.5456 18 19.3087 17.6839 19.8713 17.1213C20.4339 16.5587 20.75 15.7956 20.75 15V7C20.75 6.20435 20.4339 5.44129 19.8713 4.87868C19.3087 4.31607 18.5456 4 17.75 4ZM3.75 2H13.75C14.0152 2 14.2696 2.10536 14.4571 2.29289C14.6446 2.48043 14.75 2.73478 14.75 3V4H3.75C3.48478 4 3.23043 3.89464 3.04289 3.70711C2.85536 3.51957 2.75 3.26522 2.75 3C2.75 2.73478 2.85536 2.48043 3.04289 2.29289C3.23043 2.10536 3.48478 2 3.75 2ZM18.75 12H17.75C17.4848 12 17.2304 11.8946 17.0429 11.7071C16.8554 11.5196 16.75 11.2652 16.75 11C16.75 10.7348 16.8554 10.4804 17.0429 10.2929C17.2304 10.1054 17.4848 10 17.75 10H18.75V12ZM18.75 8H17.75C16.9544 8 16.1913 8.31607 15.6287 8.87868C15.0661 9.44129 14.75 10.2044 14.75 11C14.75 11.7956 15.0661 12.5587 15.6287 13.1213C16.1913 13.6839 16.9544 14 17.75 14H18.75V15C18.75 15.2652 18.6446 15.5196 18.4571 15.7071C18.2696 15.8946 18.0152 16 17.75 16H3.75C3.48478 16 3.23043 15.8946 3.04289 15.7071C2.85536 15.5196 2.75 15.2652 2.75 15V5.83C3.07127 5.94302 3.40943 6.00051 3.75 6H17.75C18.0152 6 18.2696 6.10536 18.4571 6.29289C18.6446 6.48043 18.75 6.73478 18.75 7V8Z"
        fill={fill}
      />
    </svg>
  );
};

export default CryptoIcon;
